export default {
  chicken: {
    name: 'Chicken',
    id: 'chicken',
    description:
    "The chicken who crossed the road. It's a mystery why it crossed the road.",
    image: require("../assets/images/characters/chicken.png"),
  },
  bacon: {
    name: "Bacon",
    id: "bacon",
    description:
      "Bacon is a type of salt-cured pork made from various cuts, typically from the pork belly or from the less fatty back cuts. It is eaten on its own, as a side dish (particularly in breakfasts), or used as a minor ingredient to flavour dishes (e.g., the club sandwich).",
    image: require("../assets/images/characters/bacon.png"),
  },
  cser: {
    name: "CS-er",
    id: "cser",
    deathParticle: "blood",
    description:
      "CS-er is a computer science student at UIT. He is not a React Native expert and struggle with Computer Graphics course  .",
    image: require("../assets/images/characters/cs_er.png"),
  },
  KimYen: {
    name: "Kim Yen",
    id: "KimYen",
    description:
      "Kim Yen is a Data Analyst who loves to jump from job to job.",
    image: require("../assets/images/characters/KimYen.png"),
  },
  HoangTan: {
    name: "Hoang Tan",
    id: "HoangTan",
    description:
      "Hoang Tan is a Software Engineer who is obbsessed with Alligators and Arch Linux.",
    image: require("../assets/images/characters/HoangTan.png"),
  },
  TramAnh: {
    name: "Tram Anh",
    id: "TramAnh",
    description:
      "Tram Anh is a Designer.",
    image: require("../assets/images/characters/TramAnh.png"),
  },
};
